import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../Search/Search";
import Title from "../../common/Title";
import BatchList from "../../common/BatchList";

import useBatchListState from "../../../hooks/useBatchListState";
import { OPERATIONS } from "../../../constants/value";
import { __getImsiWorkflowBatches } from "../../../api/sim";

const IMSIWorkflow = ({ client }) => {
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);

  const {
    data,
    loading,
    metaData,
    response,
    statusCategories,
    handlePageChange,
    handlePageSizeChange,
    handleStatusCategoryChange,
  } = useBatchListState(__getImsiWorkflowBatches, { client });

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Title
          variant="h5"
          sx={{ textTransform: "capitalize" }}
          content={`${client ? client : ""} IMSI Workflow`}
          gutterBottom
        />
        <Search
          key={`${client}-imsi-workflow`}
          client={client}
          operation={OPERATIONS.imsi_workflow}
          searchActive={searchActive}
          setSearchActive={setSearchActive}
        />
        {/* if search not active show as desired */}
        {!searchActive &&
          (response ? (
            <>
              <Grid container justifyContent="flex-start" spacing={2}>
                <Grid item>
                  <Stack spacing={2} direction="row">
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => nav("form")}
                    >
                      {`IMSI Workflow`}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
              <BatchList
                data={data}
                loading={loading}
                meta={metaData}
                changeNumber={false}
                statusCategories={statusCategories}
                onStatusCategoryChange={handleStatusCategoryChange}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
              />
            </>
          ) : (
            <Title content="Please wait..." variant="subtitle2" gutterBottom />
          ))}
      </Box>
    </>
  );
};

export default IMSIWorkflow;
